import React from 'react';

import './App.css';
import 'video-react/dist/video-react.css';
import Routes from './Routes';

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
